// The seven finding states (D84). Icon, colour and Bulgarian label in one place, in ladder
// order, so every screen says the same thing about the same state.

import { FINDING_STATES, type FindingState } from '@leadg/shared';

interface StateMeta {
  icon: string;
  label: string;
  varName: string;
}

const META: Record<FindingState, StateMeta> = {
  unknown: { icon: '❓', label: 'Непроверено', varName: '--state-unknown' },
  missing: { icon: '❌', label: 'Липсва', varName: '--state-missing' },
  optional_missing: { icon: 'ℹ️', label: 'По избор', varName: '--state-optional' },
  broken: { icon: '🔧', label: 'Счупено', varName: '--state-broken' },
  subpar: { icon: '⚠️', label: 'Може по-добре', varName: '--state-subpar' },
  enhance: { icon: '💡', label: 'Подобрение', varName: '--state-enhance' },
  ok: { icon: '✅', label: 'Има го', varName: '--state-ok' },
};

export function stateLabel(state: FindingState): string {
  return META[state].label;
}

export function StateIcon({
  state,
  showLabel = false,
}: {
  state: FindingState;
  showLabel?: boolean;
}) {
  const meta = META[state];
  return (
    <span className="state" style={{ color: `var(${meta.varName})` }} title={meta.label}>
      <span aria-hidden="true">{meta.icon}</span>
      {showLabel ? (
        <span className="state__label">{meta.label}</span>
      ) : (
        <span className="sr-only">{meta.label}</span>
      )}
    </span>
  );
}

/** The legend, in the ladder's own order — which is also the classification order. */
export function StateLegend() {
  return (
    <div className="legend">
      {FINDING_STATES.filter((state) => state !== 'enhance').map((state) => (
        <StateIcon key={state} state={state} showLabel />
      ))}
    </div>
  );
}
